import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/ignission/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["BlogViewLogger"] */ "/Users/oscararmstrong/node/ignission/src/app/blog/[slug]/BlogViewLogger.tsx");
